import { stationList, stationAdd, stationEdit, stationDelete,
          transcodeModeList, transcodeModeAdd, transcodeModeEdit, transcodeModeDelete} from '@/api/stations'

const actions = {
  stationList(context, body) {
    return new Promise((resolve, reject) => {
      stationList(body).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  stationAdd(context, body) {
    return new Promise((resolve, reject) => {
      stationAdd(body).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  stationEdit(context, body) {
    return new Promise((resolve, reject) => {
      stationEdit(body).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  stationDelete(context, body) {
    return new Promise((resolve, reject) => {
      stationDelete(body).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  transcodeModeList(context, body) {
    return new Promise((resolve, reject) => {
      transcodeModeList(body).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  transcodeModeAdd(context, body) {
    return new Promise((resolve, reject) => {
      transcodeModeAdd(body).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  transcodeModeEdit(context, body) {
    return new Promise((resolve, reject) => {
      transcodeModeEdit(body).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  transcodeModeDelete(context, body) {
    return new Promise((resolve, reject) => {
      transcodeModeDelete(body).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }

}

export default {
  namespaced: true,
  actions
}